import React from "react";
import { Route, Routes } from "react-router-dom";

import Workflow from "@/components/screens/Workflow";
import WorkflowFormPage from "@/components/screens/WorkflowFormPage";
import WorkflowViewPage from "@/components/screens/WorkflowView";
import { WORKFLOW_EDIT_DIALOG_MESSAGES } from "@/messages/workflow/workflow-edit-dialog.messages";
import { WORKFLOW_MESSAGES } from "@/messages/workflow/workflow.messages";

const WorkflowPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<Workflow messages={WORKFLOW_MESSAGES} />} />
      <Route
        path="/update/:workflowId/:lang"
        element={<WorkflowFormPage messages={WORKFLOW_EDIT_DIALOG_MESSAGES} isEditing />}
      />
      <Route
        path="/flow/:workflowId/:lang"
        element={<WorkflowViewPage messages={WORKFLOW_MESSAGES} />}
      />
      <Route path="/" element={<Workflow messages={WORKFLOW_MESSAGES} />} />
    </Routes>
  );
};

export default WorkflowPage;
